function initializePriceCatalog() {
  const root = document.querySelector("[data-price-catalog]")
  if (!root || root.priceCatalogInitialized) return
  root.priceCatalogInitialized = true

  const form = root.querySelector("[data-catalog-form]")
  const results = root.querySelector("[data-catalog-results]")
  const feedback = root.querySelector("[data-catalog-feedback]")
  const searches = Array.from(form.querySelectorAll("[data-catalog-search]"))
  let timer
  let request
  let revision = 0
  let appliedURL = formURL().href

  function cancelPending() {
    clearTimeout(timer)
    revision += 1
    if (request) request.abort()
    results.removeAttribute("aria-busy")
  }

  function formURL() {
    const url = new URL(form.action)
    new FormData(form).forEach((value, key) => {
      if (searches.some(field => field.name === key) && value.trim().length < 3) return
      if (value) url.searchParams.set(key, value)
    })
    return url
  }

  function searchHint() {
    return searches.some(field => field.value.trim().length > 0 && field.value.trim().length < 3)
      ? "Escribe al menos 3 caracteres en cada búsqueda para aplicar ese filtro." : ""
  }

  async function load(url) {
    cancelPending()
    const currentRevision = revision
    request = new AbortController()
    results.setAttribute("aria-busy", "true")
    feedback.textContent = "Actualizando precios…"
    const oldScroll = results.querySelector(".price-catalog__table-wrap").scrollLeft
    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" }, credentials: "same-origin", cache: "no-store", signal: request.signal
      })
      if (!response.ok || response.redirected) throw new Error("No se pudo cargar el reporte")
      const data = await response.json()
      if (currentRevision !== revision || !root.isConnected) return
      results.innerHTML = data.html
      results.querySelector(".price-catalog__table-wrap").scrollLeft = oldScroll
      form.elements.sort.value = url.searchParams.get("sort") || "code"
      form.elements.direction.value = url.searchParams.get("direction") || "asc"
      history.replaceState(history.state, "", url.pathname + url.search)
      appliedURL = url.href
      feedback.textContent = searchHint() || `${results.querySelector("[data-catalog-count]").textContent}. Resultados actualizados.`
    } catch (error) {
      if (error.name !== "AbortError" && currentRevision === revision) {
        feedback.textContent = "No se pudieron actualizar los precios. Intenta de nuevo con el botón Actualizar."
      }
    } finally {
      if (currentRevision === revision) results.removeAttribute("aria-busy")
    }
  }

  searches.forEach(search => search.addEventListener("input", () => {
    cancelPending()
    feedback.textContent = searchHint()
    // On shortening the query, reload the unfiltered list rather than retaining stale matches.
    if (formURL().href === appliedURL) return
    timer = setTimeout(() => load(formURL()), 280)
  }))

  form.addEventListener("change", event => {
    if (!searches.includes(event.target)) load(formURL())
  })
  form.addEventListener("submit", event => {
    event.preventDefault()
    load(formURL())
  })
  root.addEventListener("click", event => {
    const link = event.target.closest("a[data-catalog-link], a[data-catalog-reset]")
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return
    event.preventDefault()
    if (link.hasAttribute("data-catalog-reset")) {
      searches.forEach(field => { field.value = "" })
      form.querySelectorAll("select").forEach(field => { field.value = "" })
      form.elements.sort.value = "code"
      form.elements.direction.value = "asc"
      load(formURL())
      return
    }
    const target = new URL(link.href)
    const url = formURL()
    ;["sort", "direction", "page"].forEach(key => {
      if (target.searchParams.has(key)) url.searchParams.set(key, target.searchParams.get(key))
    })
    load(url)
  })

  document.addEventListener("turbolinks:before-cache", cancelPending, { once: true })
}

document.addEventListener("turbolinks:load", initializePriceCatalog)
document.addEventListener("DOMContentLoaded", initializePriceCatalog)
